import React from 'react';

import { TMHappy } from './Icons/TMHappy';
import { TMNeutral } from './Icons/TMNeutral';
import { TMSad } from './Icons/TMSad';
import * as Styled from './style';

function Votes({ votesCount }) {
  return (
    <Styled.VotedCount>
      <span>{votesCount}</span>
      <small>{votesCount === 1 ? 'Vote' : 'Votes'}</small>
    </Styled.VotedCount>
  );
}

function TeamMoodRow({
  index,
  question,
  mood,
  defaultMoods,
  handleMood,
  statistics,
  isSummary,
}) {
  const emojiElement = (m, emojiIndex) =>
    isSummary ? (
      <Styled.Statistic key={emojiIndex}>
        <span>{statistics[m]}</span>

        {/* eslint-disable-next-line no-nested-ternary */}
        {m === 'happy' ? (
          <TMHappy responsive={isSummary} />
        ) : m === 'neutral' ? (
          <TMNeutral responsive={isSummary} />
        ) : (
          <TMSad responsive={isSummary} />
        )}
      </Styled.Statistic>
    ) : (
      <Styled.RadioBlock key={emojiIndex}>
        <input
          type="radio"
          id={`${m}${question}`}
          onChange={() => handleMood(index, m)}
          checked={mood === m}
        />
        <label htmlFor={`${m}${question}`}>
          {/* eslint-disable-next-line no-nested-ternary */}
          {m === 'happy' ? (
            <TMHappy />
          ) : m === 'neutral' ? (
            <TMNeutral />
          ) : (
            <TMSad />
          )}
        </label>
      </Styled.RadioBlock>
    );

  return (
    <Styled.Row responsive={isSummary}>
      {isSummary && <Votes votesCount={statistics.total} />}
      <Styled.Question>{question}</Styled.Question>
      {defaultMoods.map((dM, index_) => emojiElement(dM, index_))}
    </Styled.Row>
  );
}

export default TeamMoodRow;
